<template>
  <div ref="container">
    <a-modal :title="title" :width="1300" :visible="visible" :maskStyle="{ 'top': '93px', 'left': '154px' }" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height:60%;">
      <a-card style="margin-bottom:30px">
        <a-descriptions title="PI注册信息">
          <a-descriptions-item label="产品名称">{{ productInfo.productName }}</a-descriptions-item>
          <a-descriptions-item label="产品规格">{{ productInfo.specificationModel }}</a-descriptions-item>
          <a-descriptions-item label="器械类别">
            <template v-if="productInfo.deviceCategory === 1">
              器械
            </template>
            <template v-else-if="productInfo.deviceCategory === 2">
              体外诊断试剂
            </template>
            <template v-else>
              {{ productInfo.deviceCategory }}
            </template>
          </a-descriptions-item>
          <a-descriptions-item label="码制">
            <template v-if='productInfo.codeSystem === "1"'>
              MA
            </template>
            <template v-else-if='productInfo.codeSystem === "2"'>
              GS1
            </template>
            <template v-else>
              {{ productInfo.codeSystem }}
            </template>
          </a-descriptions-item>
          <a-descriptions-item label="产品DI">{{ productInfo.productDi }}</a-descriptions-item>
          <a-descriptions-item label="包装级别">{{ productInfo.packageLevel }}</a-descriptions-item>
          <a-descriptions-item label="分类编码">{{ productInfo.categoryCode }}</a-descriptions-item>
          <a-descriptions-item label="序列号长度">{{ productInfo.serialLength }}</a-descriptions-item>
          <a-descriptions-item label="序列号前缀">{{ productInfo.serialPrefix }}</a-descriptions-item>
          <a-descriptions-item label="序列号起始号">{{ productInfo.serialStartNum }}</a-descriptions-item>
          <a-descriptions-item label="序列号终止号">{{ productInfo.serialEndNum }}</a-descriptions-item>
          <a-descriptions-item label="生产日期" v-if="productInfo.startDate">{{ changeDate(productInfo.startDate)
          }}</a-descriptions-item>
          <a-descriptions-item label="生产批号">{{ productInfo.batchNumber }}</a-descriptions-item>
          <a-descriptions-item label="有效期">{{ productInfo.effectiveDate }}</a-descriptions-item>
          <a-descriptions-item label="失效期" v-if="productInfo.endDate">{{
            changeDate(productInfo.endDate) }}</a-descriptions-item>
          <a-descriptions-item label="灭菌批号">{{ productInfo.dBatchNumber }}</a-descriptions-item>
        </a-descriptions>
      </a-card>
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="8" :lg="6"  :sm="24">
              <a-form-item label="产品UDI编码">
                <a-input placeholder="请输入产品UDI-PI编码" v-model="search"></a-input>
              </a-form-item>
            </a-col>
            <span style="float:left;overflow:hidden;" class="table-page-search-submitButtons">
              <a-col :md="8" :lg="6"  :sm="24" >
                <a-button type="primary" @click="searchQuery">查询</a-button>
                <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
              </a-col>
            </span>
            <span style="float:right;overflow:hidden;" class="table-page-search-submitButtons">
              <a-col :md="8" :lg="6"  :sm="24" >
                <a-button type="primary" @click="invalidateConfirm(invalidate)">作废</a-button>
              </a-col>
            </span>
          </a-row>
        </a-form>
      </div>

      <a-tabs v-model="tabs" @change="handleTabsChange">
        <a-tab-pane key="1" tab="有效">
          <a-table :dataSource="dataSource" :rowKey="(record, index) => { return index }"
                   :pagination="ipagination" :loading="loading" :columns="columns" @change="handleTableChange"
                   :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,columnWidth:'30px'}"
          >
            <span slot="action" slot-scope="text, record">
              <a v-if="record.status != 3" @click="myHandleDetailPI(record)">打印</a>
              <a-divider type="vertical" />
              <a v-if="record.status != 3" @click="invalidateUDI(record)">作废</a>
            </span>
                <span slot="packageSpec" slot-scope="text, record">
              <span>初级包装:{{ record.packageSpecification }}</span>
            </span>

                <span slot="status" slot-scope="text, record">
              <span v-if="record.status == 1">待激活</span>
              <span v-if="record.status == 2">已打印</span>
              <span v-if="record.status == 3">废除</span>
            </span>

                <span slot="startDate" slot-scope="text, record">
              <span v-if="record.startDate">{{ changeDate(record.startDate) }}</span>
              <span v-else></span>
            </span>
                <span slot="endDate" slot-scope="text, record">
              <span v-if="record.endDate">{{ changeDate(record.endDate) }}</span>
              <span v-else></span>
            </span>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="2" tab="失效">
          <a-table :dataSource="dataSource2"
                   :pagination="ipagination2" :columns="columns" @change="handleTableChange"
          >

            <span slot="packageSpec" slot-scope="text, record">
              <span>初级包装:{{ record.packageSpecification }}</span>
            </span>

            <span slot="status" slot-scope="text, record">
              <span v-if="record.status == 1">待激活</span>
              <span v-if="record.status == 2">已打印</span>
              <span v-if="record.status == 3">废除</span>
            </span>

                <span slot="startDate" slot-scope="text, record">
              <span v-if="record.startDate">{{ changeDate(record.startDate) }}</span>
              <span v-else></span>
            </span>
                <span slot="endDate" slot-scope="text, record">
              <span v-if="record.endDate">{{ changeDate(record.endDate) }}</span>
              <span v-else></span>
            </span>
          </a-table>
        </a-tab-pane>
      </a-tabs>


    </a-modal>
    <SelectModel ref="SelectModelref"></SelectModel>
    <allSelectModel ref="allSelectModelRef" @updateTableData ='handlePrintSuccess'></allSelectModel>
  </div>
</template>
<script>
import SelectModel from './SelectModel.vue'
import allSelectModel from './allSelectModel.vue'
import { piInfoApi, getPIInfo, batchDelete } from '@/api/api'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import startPrint from '@/views/UDIadmin/modules/allPrint'
import { BillListMixin } from '@views/UDIadmin/mixins/BillListMixin'
import { postAction } from '@api/manage'
export default {
  name: 'VendorModal',
  mixins: [JeecgListMixin],
  components: {
    SelectModel,
    allSelectModel,
  },
  data() {
    return {
      tabs:'1',
      title: 'PI列表',
      visible: false,
      model: {},
      dataSource: [],
      dataSource2: [],
      loading: false,
      productInfo: {},
      search: '',
      moduleUUid: '',
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30', '50', '100'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      ipagination2: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30', '50', '100'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      isorter: {
        column: 'createTime',
        order: 'desc',
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'seq',
          width: 60,
        },
        {
          title: '产品UDI编码',
          dataIndex: 'productDi',
          width: 150,
        },
        {
          title: '序列号',
          dataIndex: 'productName',
        },
        {
          title: '产品名称',
          dataIndex: 'productName',
        },
        // {
        //   title: '品类编码',
        //   dataIndex: 'productNo',
        // },
        {
          title: '打印次数',
          dataIndex: 'printNum',
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          width: 90,
        },
        // {
        //   title: '包装规格',
        //   dataIndex: 'packageSpecification',
        //   scopedSlots: { customRender: 'packageSpec' },
        // },
        // {
        //   title: '生产日期',
        //   dataIndex: 'startDate',
        //   scopedSlots: { customRender: 'startDate' },
        // },
        // {
        //   title: '生产批号',
        //   dataIndex: 'batchNumber',
        // },
        // {
        //   title: '灭菌批号',
        //   dataIndex: 'dBatchNumber',
        // },
        // {
        //   title: '失效日期',
        //   dataIndex: 'endDate',
        //   scopedSlots: { customRender: 'endDate' },
        // },
        // {
        //   title: '序列号',
        //   dataIndex: 'serialNumber',
        // },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 180,
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  created() {},
  methods: {
    invalidate(){
      console.log('invalidate===>',this.selectionRows)
      const ids = this.selectionRows.map(obj=>obj.detailId)
      postAction('/productPi/batchDelete',ids).then(res=>{
        this.$message.success(res.message)
        this.searchQuery()
      }).catch(res=>{
        this.$message.error(res.message)
        this.searchQuery()
      })
    },
    //判断
    searchQuery() {
      this.getlist()
    },
    searchReset() {
      this.search = ''
      this.getlist()
    },
    changeDate(Date) {
      return Date.substring(0, 10)
    },
    // 全部打印
    allPrint() {
      this.$refs.allSelectModelRef.add(this.dataSource)
      // console.log(this.$notification)
      // startPrint(this.dataSource)
    },
    async add(e,id) {
      this.visible = true
      this.loading = true
      this.moduleUUid = id
      if (e.id) {
        // 获取产品信息
        this.id = e.id
        this.ipagination.pageSize = 10
        this.ipagination.current = 1
        const result = await getPIInfo({ id: e.id })
        if (result.errno == 200 && result.errmsg == '成功') {
          // 获取PI列表
          this.productInfo = result.data.list[0]
          this.getlist()
        } else {
          this.$message.error(res.data || res.errmsg)
          this.loading = false
        }
      }
    },
    handlePrintSuccess(){
      this.getlist()
    },
    // 点击有效失效
    handleTabsChange(key) {
      if (key === '1') {
        this.getlist();
        console.log('这是有效')
      } else if (key === '2') {
        console.log('这是失效')
        this.getInvalidList();
      }
    },
    // 获取有效的表格数据
    async getlist() {
      this.loading = true
      let params = {
        search: this.search ? this.search : '',
        id: this.id,
        page: this.ipagination.current,
        limit: this.ipagination.pageSize,
        ifValid:0
      }
      const res = await piInfoApi(params)
      if (res.errno == 200 && res.errmsg == '成功') {
        if( res.data.list.length == 0 ){
          this.$message.error('未查询到相关数据！')
          this.dataSource = []
          this.ipagination.total = 0
        } else {
          this.dataSource = res.data.list
          this.ipagination.total = res.data.total
        }
        this.loading = false
      } else {
        this.$message.error(res.data || res.errmsg)
        this.dataSource = []
        this.loading = false
      }
    },
    // 获取失效的表格数据
    async getInvalidList() {
      this.loading = true
      let params1 = {
        search: this.search ? this.search : '',
        id: this.id,
        page: this.ipagination.current,
        limit: this.ipagination.pageSize,
        ifValid:1
      }
      const res2 = await piInfoApi(params1)
      if (res2.errno == 200 && res2.errmsg == '成功') {
        if( res2.data.list.length == 0 ){
          this.$message.error('未查询到相关数据！')
        } else {
          this.dataSource2 = res2.data.list
          this.ipagination2.total = res2.data.total
        }
        
      } else {
        this.$message.error(res2.data || res2.errmsg)
        this.dataSource2 = []
      }
    },
    handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc'
      }
      if (pagination && pagination.current) {
        this.ipagination = pagination
      }
      this.getlist()
    },
    async myHandleDetailPI(record) {
      // this.$refs.SelectModelref.add(record)
      // info是模版uuid
      const info = this.moduleUUid
      let type = 'Singleprinting'
      this.$refs.allSelectModelRef.addStr(record, type, info)
    },
    // 作废
    invalidateUDI(record){
      this.$confirm('是否作废数据?', '确认操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.handleInvalidate(record)
      }).catch(() => {});
    },
    async handleInvalidate(record){
      const id = record.detailId
      const params = [id]
      const res = await batchDelete(params)
      if(res.code === 200 && res.success == true ){
        this.$message.success('作废成功')
        this.getlist()
      } else {
        this.$message.error(res.message)
      }
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    initShow(e){
        this.visible = true
    },
    handleOk() {
      // 触发表单验证
      this.handleCancel()
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>
<style scoped></style>